import { EmployeeContributionTypeEnum } from '../../types/enums';

const userCompleteOnboarding = async (
	token: string,
	contributionType: EmployeeContributionTypeEnum,
	pensionContribution: number | string,
	gender: string,
	name: string,
	firstSurname: string,
	lastSurname: string,
	nif: string,
	email: string,
	password: string,
	birthdate: string,
	closingPayrollDay?: number,
	agencyEmail?: string,
	fileData?: string,
	individualPensionData?: {
		hasIndividualPensionPlan: boolean | null;
		individualPensionAmount: number;
	},
	flexibleCompensationData?: {
		usesFlexibleCompensation: boolean | null;
		acceptsCompanyHealthInsurance: boolean;
		usesTransport: boolean;
		usesFood: boolean;
		usesChildcare: boolean;
		childcareMonthlyAmount: number;
		usesTraining: boolean;
		trainingAnnualAmount: number;
	},
	flexibleCompensationCompanyConfig?: {
		hasCompanyHealthInsurance: boolean;
		companyHealthInsuranceAmount: number;
		transportAvailable: boolean;
		transportAmount: number;
		foodAvailable: boolean;
		foodAmount: number;
		childcareAvailable: boolean;
		childcareAmount: number;
		trainingAvailable: boolean;
		trainingAmount: number;
	}
) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/complete-onboarding`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify({
			contributionType,
			pensionContribution: Number(pensionContribution),
			password,
			gender,
			name,
			firstSurname,
			lastSurname,
			nif,
			email,
			birthdate,
			closingPayrollDay,
			agencyEmail,
			fileData,
			hasIndividualPensionPlan: individualPensionData?.hasIndividualPensionPlan || null,
			individualPensionAmount: individualPensionData?.individualPensionAmount || 0,
			flexibleCompensationData,
			flexibleCompensationCompanyConfig
		})
	});

	return response.json();
};

export default userCompleteOnboarding;
